// TILT-SUPPORT
import controller from './chart-tilt.controller';
import { template, bindings } from '../chart-abstract-base';

export default {
    bindings,
    template,
    controller
};